import { ReactiveMap } from "@solid-primitives/map";
import { ReactiveSet } from "@solid-primitives/set";
import { File } from "../classes/File.js";
import { ServerRole } from "../classes/ServerRole.js";
export const serverHydration = {
    keyMapping: {
        _id: "id",
        owner: "ownerId",
        channels: "channelIds",
        system_messages: "systemMessages",
        default_permissions: "defaultPermissions",
    },
    functions: {
        id: (server) => server._id,
        ownerId: (server) => server.owner,
        name: (server) => server.name,
        description: (server) => server.description,
        channelIds: (server) => new ReactiveSet(server.channels),
        categories: (server) => server.categories ?? [],
        systemMessages: (server) => server.system_messages ?? {},
        roles: (server, ctx) => new ReactiveMap(Object.keys(server.roles).map((id) => [
            id,
            new ServerRole(ctx, server._id, id, server.roles[id]),
        ])),
        defaultPermissions: (server) => BigInt(server.default_permissions),
        icon: (server, ctx) => new File(ctx, server.icon),
        banner: (server, ctx) => new File(ctx, server.banner),
        flags: (server) => server.flags,
        analytics: (server) => server.analytics || false,
        discoverable: (server) => server.discoverable || false,
        discoveryJoinMode: (server) => server.discovery?.join_mode ?? "join",
        nsfw: (server) => server.nsfw || false,
        tier: (server) => server.tier,
    },
    initialHydration: () => ({
        channelIds: new ReactiveSet(),
        roles: new ReactiveMap(),
        discoveryJoinMode: "join",
    }),
};
/**
 * Flags attributed to servers
 */
export var ServerFlags;
(function (ServerFlags) {
    ServerFlags[ServerFlags["Official"] = 1] = "Official";
    ServerFlags[ServerFlags["Verified"] = 2] = "Verified";
})(ServerFlags || (ServerFlags = {}));
